import { fetch, getPaging, Method } from 'core/api/fetch';
import { validateRequiredString } from '@utriper/core';

const BASE_URL = '/api/v1.1.1/experiencer/';

const getExperienceURL = (experienceId) => `${BASE_URL}experience/${experienceId}/unitlink`;

const UnitLinksRoutes = {
    addExperienceLink: getExperienceURL,
    getExperienceLink: (experienceId, options, params) => `${getExperienceURL(experienceId)}?${params}&${getPaging(options)}`,
    updateExperienceLink: (experienceId, linkId) => `${getExperienceURL(experienceId)}/${linkId}`,
};

export const UnitLinksService = {
    addExperienceLink: async (experienceId, linkData) => {
        try {
            const { data } = await fetch(UnitLinksRoutes.addExperienceLink(experienceId), {
                method: Method.POST,
                authenticated: true,
                data: linkData,
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return data;
        } catch (error) {
            throw error;
        }
    },
    getExperienceLink: async (experienceId, options) => {
        try {
            const params = new URLSearchParams();

            if (validateRequiredString(options?.name, null)) {
                params.append('name', options.name);
            }

            if (Array.isArray(options?.unitType) && options?.unitType?.length > 0) {
                options.unitType.forEach(({ id }) => params.append('unitType', id));
            }

            if (options?.isActive === 'true' || options?.isActive === 'false') {
                params.append('isActive', options.isActive);
            }

            const { data } = await fetch(UnitLinksRoutes.getExperienceLink(experienceId, options, params.toString()), {
                method: Method.GET,
                authenticated: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return data;
        } catch (error) {
            throw error;
        }
    },
    updateExperienceLink: async (experienceId, linkId, linkData) => {
        try {
            const { data } = await fetch(UnitLinksRoutes.updateExperienceLink(experienceId, linkId), {
                method: Method.PATCH,
                authenticated: true,
                data: { ...linkData },
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return data;
        } catch (error) {
            throw error;
        }
    },
};
